import React from "react";
import { Dropdown } from "semantic-ui-react";

const DropDownList = ({
  options,
  name,
  placeholder,
  fluid,
  selection,
  onBlur,
  onChange,
  value,
  defaultValue,
  className,
  search,
  clearable = false,
  loading = false,
  disabled = false,
  style
}) => {
  // Transform options to include icons, flags, and custom rendering
  const transformedOptions = options.map(option => {
    // Handle header items (non-selectable)
    if (option.isHeader) {
      return {
        ...option,
        text: (
          <div style={{
            padding: '8px 12px',
            fontWeight: 600,
            fontSize: '0.85rem',
            color: '#6c757d',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            backgroundColor: '#f8f9fa',
            borderTop: '1px solid #e9ecef',
            borderBottom: '1px solid #e9ecef',
            margin: '4px 0'
          }}>
            {option.text}
          </div>
        )
      };
    }

    // Handle regular items with icons
    const hasIcon = option.icon && option.icon.trim() !== '';

    // Determine if icon is a class name (starts with common icon prefixes) or an emoji/HTML entity
    const isIconClassName = hasIcon && (
      option.icon.trim().startsWith('bi ') ||
      option.icon.trim().startsWith('bi-') ||
      option.icon.trim().startsWith('fa ') ||
      option.icon.trim().startsWith('fa-') ||
      option.icon.trim().includes('icon')
    );

    // Render icon - either as an <i> element for class names, or directly for emojis/HTML entities
    const iconDisplay = hasIcon ? (
      <span
        style={{
          marginRight: '8px',
          fontSize: '1.1em',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '20px',
          height: '20px',
          lineHeight: '1',
          flexShrink: 0
        }}
      >
        {isIconClassName ? (
          <i className={option.icon.trim()}></i>
        ) : (
          option.icon
        )}
      </span>
    ) : null;

    return {
      ...option,
      text: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {iconDisplay}
          <span>{option.text}</span>
        </span>
      ),
      // Also store the icon for use in selected value display
      content: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <span>{option.text}</span>
        </span>
      )
    };
  });

  // Custom onChange handler to prevent header selection
  const handleChange = (e, data) => {
    // Prevent selection of header items
    if (data.value === 'non-deductible-header' || data.value === 'deductible-header') {
      return; // Don't allow header selection
    }
    if (onChange) {
      onChange(e, data);
    }
  };

  return (
    <Dropdown
      name={name}
      search={search}
      clearable={clearable}
      placeholder={placeholder}
      className={className}
      fluid={fluid}
      selection={selection}
      options={transformedOptions}
      onChange={handleChange}
      onBlur={onBlur}
      value={value === 'non-deductible-header' || value === 'deductible-header' ? undefined : value} // Prevent header from being selected
      loading={loading}
      defaultValue={defaultValue === 'non-deductible-header' || defaultValue === 'deductible-header' ? undefined : defaultValue}
      disabled={disabled}
      style={style}
    />
  );
};

export { DropDownList };
